import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["matra", "phase", "cycles", "alternation", "phaseDuration", "code", "duration", "cycleSummary", "bothSides", "error"]
  static values = { labels: Object }

  connect() {
    this.render()
  }

  step(event) {
    const input = event.currentTarget.closest(".input-group").querySelector("input")
    if (event.params.direction > 0) input.stepUp()
    else input.stepDown()
    input.dispatchEvent(new Event("input", { bubbles: true }))
  }

  render() {
    const fields = [this.matraTarget, this.cyclesTarget, ...this.phaseTargets]
    const multiplier = ["nadishodhana", "anuloma", "pratiloma"].includes(this.alternationTarget.value) ? 2 : 1
    this.bothSidesTarget.hidden = multiplier !== 2
    const valid = fields.every(field => field.value !== "" && field.validity.valid)
    const seconds = this.phaseTargets.map(field => Number(field.value) * Number(this.matraTarget.value))
    const cycleDuration = seconds.reduce((sum, duration) => sum + duration, 0) * multiplier
    const total = cycleDuration * Number(this.cyclesTarget.value)
    const calculable = valid && total > 0 && Number.isSafeInteger(total)
    this.errorTarget.hidden = calculable
    this.codeTarget.textContent = valid ? seconds.join("-") : "—"
    this.phaseDurationTargets.forEach((target, index) => {
      target.textContent = valid ? ((index === 1 || index === 3) && seconds[index] === 0
        ? this.labelsValue.skipped_phase : this.format(this.labelsValue.phase_duration, { seconds: seconds[index] })) : "—"
    })
    this.durationTarget.textContent = calculable ? this.format(this.labelsValue.duration_format, {
      minutes: Math.floor(total / 60), seconds: total % 60
    }) : "—"
    const count = Number(this.cyclesTarget.value)
    this.cycleSummaryTarget.textContent = calculable ? this.format(
      this.labelsValue.cycle_summary[count === 1 ? "one" : "other"], { count, seconds: cycleDuration }
    ) : ""
  }

  format(template, values) {
    return template.replace(/%\{(\w+)\}/g, (_, key) => values[key])
  }
}
